import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { map } from "lodash";
import { useStoreState } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";

function GeneralSidebar() {
  const { t } = useTranslation();

  const { name } = useStoreState(state => state.selection.fan);
  const enabledFeatures = useStoreState(state => state.selection.features);
  const fanCode = useStoreState(state => state.selection[types.FAN_CODE]);
  const availability = useStoreState(state => state.selection[types.FAN_AVAILABILITY]);
  const prices = useStoreState(state => state.selection[types.FAN_PRICES]);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const menuRef = useRef(null);

  if (!menuRef.current) {
    // Create once
    menuRef.current = document.getElementById("fan-general-sidebar");
    menuRef.current.innerHTML = "";
  }

  const domElement = menuRef.current;

  return ReactDOM.createPortal(
    <>
      {
        name &&
        <div className="panel panel-info">
          <div className="panel-heading">
            { t('frontend:fan.model') }
          </div>
          <div className="panel-body">
            { name }
          </div>
        </div>
      }
      {
        fanCode &&
        <div className="panel panel-info">
          <div className="panel-heading">
            { t('frontend:fan.code') }
          </div>
          <div className="panel-body">
            { fanCode }
          </div>
        </div>
      }
      {
        map((prices || {}), (price, name) =>
          <div key={`${name}-${price}`} className="panel panel-info">
            <div className="panel-heading">
              { window.FwApp.uiPreferences.priceName }
              { name !== "main" && <span v-if="key != 'main'"> ({ name })</span> }
            </div>
            <div className="panel-body">
              { price["formatted"] }
            </div>
          </div>
        )
      }
      {
        enabledFeatures.includes("availability") && availability &&
        <div className="panel panel-info">
          <div className="panel-heading">
            { t('frontend:availability.availability') }
            <div className="inline-block relative cursor-pointer ml-2" data-controller="tooltip" data-action="mouseenter->tooltip#show mouseleave->tooltip#hide">
              <i className="fa fa-info-circle cursor-pointer"></i>
              <div className="tooltip" data-tooltip-target="tooltip">
                {t('frontend:availability.info')}
                <div className="tooltip-arrow" data-tooltip-target="arrow"></div>
              </div>
            </div>
          </div>
          <div className="panel-body">
            { availability }
          </div>
        </div>
      }
    </>
    , domElement
  );
}

export default GeneralSidebar;
